import { SEO_PAGE_SLUGS } from './seoPages';

export const RESERVED_PROFILE_SLUGS = new Set([
  'admin',
  'api',
  'assets',
  'auth',
  'blueprint',
  'copyright',
  'cookies',
  'csp-report',
  'dashboard',
  'discover',
  'embed',
  'guidelines',
  'ledger',
  'login',
  'og',
  'privacy',
  'register',
  'settings',
  'terms',
  'trademarks',
  ...SEO_PAGE_SLUGS,
]);

export const isReservedProfileSlug = (value = '') => (
  RESERVED_PROFILE_SLUGS.has(String(value || '').trim().toLowerCase())
);
